import { useCreateAgentEntryPoint } from '../../CreateAgent/useCreateAgentEntryPoint.ts';

import type { UseMenuItemProps, UseMenuItemReturnProps } from './index.tsx';
import { useInlineCreateAgentItem } from './useInlineCreateAgentItem.tsx';
import { useStudioRedirectCreateAgentItem } from './useStudioRedirectCreateAgentItem.tsx';

const CREATE_AGENT_SOURCE = 'globalCreateDropdown';
const INLINE_CREATE_AGENT_SOURCE = `${CREATE_AGENT_SOURCE}-inlineCreateAgent`;
const STUDIO_REDIRECT_CREATE_AGENT_SOURCE = `${CREATE_AGENT_SOURCE}-createAgent`;

type UseCreateAgentItemProps = Omit<UseMenuItemProps, 'source'> & { isMenuOpen?: boolean };

export function useCreateAgentItem({
	isMenuOpen,
	...menuItemProps
}: UseCreateAgentItemProps): [item: UseMenuItemReturnProps, shouldRender: boolean] {
	const {
		shouldRenderInlineCreateAgentItem,
		shouldRenderStudioRedirectCreateAgentItem,
		isLoading,
	} = useCreateAgentEntryPoint({
		isMenuOpen,
		source: CREATE_AGENT_SOURCE,
	});

	const inlineCreateAgent = useInlineCreateAgentItem({
		...menuItemProps,
		source: INLINE_CREATE_AGENT_SOURCE,
		isLoading,
	});

	const studioRedirectCreateAgent = useStudioRedirectCreateAgentItem({
		...menuItemProps,
		source: STUDIO_REDIRECT_CREATE_AGENT_SOURCE,
		isLoading,
	});

	if (shouldRenderInlineCreateAgentItem && inlineCreateAgent) {
		return [inlineCreateAgent, true];
	}

	if (shouldRenderStudioRedirectCreateAgentItem && studioRedirectCreateAgent) {
		return [studioRedirectCreateAgent, true];
	}

	return [studioRedirectCreateAgent, false];
}
